<template>
  <div class="about">
    <h1>This is an about page</h1>
    <h2>This is a sub about page</h2>
  </div>
</template>

<script>
export default {
  name: 'about',
  components:{

  }
}
</script>